import { createSlice } from "@reduxjs/toolkit";
import {
  getDefaultPaymentTerms,
  getUserPricingModules,
} from "../../../thunks/common-thunks/commonThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  error: null,
};

export const pricingModuleSlice = createSlice({
  name: "pricingModule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserPricingModules.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserPricingModules.fulfilled, (state, action) => {
        state.isLoading = false;
        state.priceList = action.payload;
      })
      .addCase(getUserPricingModules.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //Fetching AMP Default Payment Terms
    builder
      .addCase(getDefaultPaymentTerms.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDefaultPaymentTerms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentTerms = action.payload;
      })
      .addCase(getDefaultPaymentTerms.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default pricingModuleSlice.reducer;
